import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FEATURES } from '../config/features';

const PANEL_BY_TYPE = { employer: '/employer-home', adult_worker: '/link-requests', worker: '/home-screen' };

function PublicHeader() {
  const [expanded, setExpanded] = useState(false);
  const userInfo = useSelector(state => state.userLogin.userInfo);
  const close = () => setExpanded(false);

  return (
    <header className="pub pub-header">
      <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
        <div className="pub-wrap d-flex flex-wrap align-items-center justify-content-between w-100">
          <Link to="/" className="pub-logo" onClick={close}>SIGMA</Link>
          <Navbar.Toggle aria-controls="pub-nav" aria-label="Menu" />
          <Navbar.Collapse id="pub-nav">
            <Nav className="ms-lg-4 me-auto">
              <Nav.Link as={Link} to="/" onClick={close}>Dla firm</Nav.Link>
              <Nav.Link as={Link} to="/dla-pracownikow" onClick={close}>Dla pracowników</Nav.Link>
              <Nav.Link as={Link} to="/pricing" onClick={close}>Cennik</Nav.Link>
              {FEATURES.exams && (
                <NavDropdown title="Egzaminy" id="pub-exams">
                  <NavDropdown.Item as={Link} to="/exam" onClick={close}>Egzamin czeladniczy</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/master-exam" onClick={close}>Egzamin mistrzowski</NavDropdown.Item>
                </NavDropdown>
              )}
              <Nav.Link as={Link} to="/about" onClick={close}>O nas</Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={close}>Kontakt</Nav.Link>
            </Nav>
            <Nav className="align-items-lg-center">
              {userInfo?.token ? (
                <Link to={PANEL_BY_TYPE[userInfo.user_type] || '/home-screen'} className="pub-btn" onClick={close}>
                  Przejdź do panelu
                </Link>
              ) : (
                <>
                  <Nav.Link as={Link} to="/login" onClick={close}>Zaloguj się</Nav.Link>
                  <Link to="/register?type=employer" className="pub-btn" onClick={close}>Załóż konto firmy</Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </header>
  );
}

export default PublicHeader;
